export default __webpack_public_path__ + "static/media/CNo.76-3.ee062fda.jpg";